import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem('bm_user');
    if (stored) {
      try { setUser(JSON.parse(stored)); } catch (e) { /* ignore */ }
    }
  }, []);

  const login = async (email, password) => {
    try {
      const res = await axios.post(`${API}/auth/admin`, { email, password }, { timeout: 15000 });
      const u = {
        id: 'admin_root',
        name: res.data.name || 'Admin',
        email: res.data.email || email,
        role: res.data.role || 'admin',
        avatar: null,
      };
      setUser(u);
      localStorage.setItem('bm_user', JSON.stringify(u));
      return { ok: true, user: u };
    } catch (e) {
      const msg = e.response?.data?.detail || e.message || 'Inloggen mislukt';
      return { ok: false, error: msg };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('bm_user');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};
